import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,

    checkbox1,
    checkbox2,
    field01a,
    field01b,
    field01c,
    field01d,
    checkbox3,
    checkbox4,
    checkbox5,
    checkbox6,
  },
} = checkout;

const initialValues = {
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",

  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [checkbox4.name]: false,
  [checkbox5.name]: false,
  [checkbox6.name]: false,
  [field01a.name]: "",
  [field01b.name]: "",
  [field01c.name]: "",
  [field01d.name]: "",
};

export default initialValues;
